import { makeStyles } from '@mui/styles';

export const useReportModalStyle = makeStyles({
  modalPaper: {
    minWidth: 320,
    minHeight: 200,
    padding: 40,
    borderRadius: '16px',
    boxSizing: 'border-box',
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
  },
  btn: {
    width: 150,
  },
  closeBtn: {
    width: '100%',
  },
  textfieldContainer: {
    width: '320px',
    marginBottom: 27,
  },
  mitigatingContainer: {
    width: '320px',
    marginBottom: 10,
  },
  checkboxContainer: {
    width: '320px',
    marginTop: -25,
    marginBottom: 5,
  },
  btnContainer: {
    width: '320px',
    display: 'flex',
  },
  h2: {
    fontSize: '24px !important',
    marginBottom: 20,
  },
  textValue: {
    fontSize: '16px !important',
    marginBottom: 20,
    color: '#000',
  },
  textLabel: {
    fontSize: '14px !important',
    color: '#757575',
    marginBottom: 5,
  },
  p: {
    marginBottom: 10,
  },
  mb10: {
    marginBottom: 10,
  },
});
